import { createSelector } from "reselect";

const pendingSupplierProductsStateSelector = (state) =>
  state.pendingSupplierProducts;
const selectById = (state, itemId) => itemId;
export const pendingSupplierProductsSelector = createSelector(
  [pendingSupplierProductsStateSelector],
  (products) => products.items
);


export const pendingSupplierProductsAsListSelector = createSelector(
  [pendingSupplierProductsSelector],
  (products) => products.map(product => ({
    name : product.name,
    _id : product._id,
 

  }))
);

export const pendingSupplierProductsIsLoadingSelector = createSelector(
  [pendingSupplierProductsStateSelector],
  (products) => products.isLoading
);

export const pendingSupplierProductsCountSelector = createSelector(
  [pendingSupplierProductsStateSelector],
  (products) => products.count
);


export const pendingSupplierProductByIdSelector = createSelector(
  [pendingSupplierProductsSelector, selectById],
  (suppliers, _id) => {
    const pendingSupplier = suppliers.find((item) => _id === item._id);
    console.log( pendingSupplier, _id)
    if (!pendingSupplier) return null;
    return pendingSupplier;
  }
);